<div class="modal-height100vh">
    <div class="modal-header">
        <div class="col-8">
            <h5 class="modal-title" id="modal-basic-title">Event Configuration</h5>
        </div>
        <div class="col-4 d-flex justify-content-end align-items-center">
            <div class="action-group">
                <div class="col-6 custom-width">
                    <span (click)="toggleAll()"><i class="mdi mdi-{{isExpanded? 'collapse': 'expand'}}-all font-size-18"></i></span>
                </div>
                <div class="col-6 custom-width">
                    <span class="" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                        <i class="mdi mdi-window-close font-size-18"></i>
                    </span>
                </div>
            </div> 
        </div>
    </div>

    <div class="modal-body ps-0 pe-0 pt-0 pb-0">
        <app-accordion *ngFor="let item of accordionItems" [title]="item.name" [isAllExpanded]="isExpanded">
            <form [formGroup]="notificationForm" content id="content">
                <div class="row col-12">
                    <div class="col-4 notification-row-style">
                        <input [id]="'email' + item.key" type="checkbox" [formControlName]="'email' + item.key" >
                        <label type="form-label" [for]="'email' + item.key">Email</label>
                    </div>
                    <div class="col-4 notification-row-style">
                        <input [id]="'sms' + item.key" type="checkbox" [formControlName]="'sms' + item.key" >
                        <label type="form-label" [for]="'sms' + item.key">SMS</label>
                    </div>
                    <div class="col-4 notification-row-style">
                        <input [id]="'whatsapp' + item.key" type="checkbox" [formControlName]="'whatsapp' + item.key" >
                        <label type="form-label" [for]="'whatsapp' + item.key">Whatsapp</label>
                    </div>
                </div>
            </form>
        </app-accordion>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="onSaveClick()" (keydown.enter)="onSaveClick()" >Save</button>
    </div> 
</div>

